export default __webpack_public_path__ + "static/media/uploader.91b4c257.svg";